module.exports = __webpack_public_path__ + "img/profile_conservative.b1be5733.png";